import { Observable } from 'rxjs'

import { request, parseAPIError, DownloadRequest } from '../../common/api'

import * as actionTypes from './actionTypes'
import * as actionCreators from './actionCreators'

// Fetch

const fetchReportCostCenterResultsEpic = action$ =>
    action$.ofType(actionTypes.FETCH).switchMap(action =>
        Observable.concat(
            Observable.of({
                type: actionTypes.FETCH_STARTED,
            }),
            request({
                method: 'GET',
                path: `report-cost-center-results?year=${action.payload}`,
            })
                .switchMap(ajaxResponse => Observable.of(actionCreators.fetchReportCostCenterResultsFulfilled(ajaxResponse.response)))
                .catch(error => Observable.of(actionCreators.fetchReportCostCenterResultsRejected(parseAPIError(error))))
                .takeUntil(action$.ofType(actionTypes.FETCH_CANCELLED, actionTypes.FETCH))
        )
    )

// Export

const exportReportCostCenterResultsEpic = (action$, store) =>
    action$.ofType(actionTypes.EXPORT).switchMap(action => {
        const year = action.payload.year
        const filters = JSON.stringify(action.payload.filters)
        const token = store.getState().auth.get('accessToken')

        new DownloadRequest({
            url: `report-cost-center-results/export?year=${year}&filters=${filters}&token=${token}`,
        }).run()

        return Observable.concat(
            Observable.of({
                type: actionTypes.EXPORT_FULFILLED,
            })
        )
    })

// Fetch details

const fetchReportCostCenterResultsDetailsEpic = action$ =>
    action$.ofType(actionTypes.FETCH_DETAILS).switchMap(action =>
        Observable.concat(
            Observable.of({
                type: actionTypes.FETCH_DETAILS_STARTED,
            }),
            request({
                method: 'GET',
                path: `report-cost-center-results/details?filters=${JSON.stringify({ ...action.payload })}`,
            })
                .switchMap(ajaxResponse => Observable.of(actionCreators.fetchReportCostCenterResultsDetailsFulfilled(ajaxResponse.response)))
                .catch(error => Observable.of(actionCreators.fetchReportCostCenterResultsDetailsRejected(parseAPIError(error))))
                .takeUntil(action$.ofType(actionTypes.FETCH_DETAILS_CANCELLED))
        )
    )

// Export details

const exportReportCostCenterResultsDetailsEpic = (action$, store) =>
    action$.ofType(actionTypes.EXPORT_DETAILS).switchMap(action => {
        const token = store.getState().auth.get('accessToken')

        new DownloadRequest({
            url: `report-cost-center-results/details/export?filters=${JSON.stringify({ ...action.payload })}&token=${token}`,
        }).run()

        return Observable.concat(
            Observable.of({
                type: actionTypes.EXPORT_DETAILS_FULFILLED,
            })
        )
    })

export default [
    fetchReportCostCenterResultsEpic,
    exportReportCostCenterResultsEpic,
    fetchReportCostCenterResultsDetailsEpic,
    exportReportCostCenterResultsDetailsEpic,
]
